import React, { useContext, useEffect, useState } from "react";
import classnames from "classnames";
import ResetState from "./resetstate";
import { GrigoraEditorContext } from "../editor/context";
import { motion } from "framer-motion";

import "./select-radio-buttons.scss";
import { generate_new_id } from "../helpers/random";
import { Tooltip } from ".";

function SelectRadioButtonInput({
  value,
  onChange,
  className,
  options = [],
  label = "",
  resetValue = 0,
  isResponsive = false,
  valueTablet,
  setValueTablet,
  resetValueTablet,
  valueMobile,
  setValueMobile,
  resetValueMobile,
  layout = "inline",
  rotateIcon,
}) {
  const [active, setActive] = useState("desktop");

  const [uniqueID, setUniqueID] = useState(generate_new_id("align-input"));

  const editorContext = useContext(GrigoraEditorContext);

  useEffect(() => {
    if (editorContext?.displaySize && isResponsive) {
      setActive(editorContext.displaySize);
    }
  }, [editorContext?.displaySize]);

  if (value === undefined || value === null) {
    value = "";
  }
  if (resetValueTablet === undefined || resetValueTablet === null) {
    resetValueTablet = "";
  }
  if (resetValueMobile === undefined || resetValueMobile === null) {
    resetValueMobile = "";
  }
  const classes = classnames(
    "grigora-select-radio-input relative select-none mb-2 text-grigora-base flex w-full items-center gap-4",
    className,
  );

  return (
    <div className={classes}>
      {label && (
        <div className="grigora-select-radio-input__label flex flex-1 items-center">
          {label}
        </div>
      )}

      <div className={`flex justify-end items-center text-editor-text-main`}>
        <div className="mr-2">
          <ResetState
            active={
              (value !== resetValue && value !== "" && value !== undefined) ||
              (valueTablet !== resetValueTablet &&
                valueTablet !== "" &&
                valueTablet !== undefined) ||
              (valueMobile !== resetValueMobile &&
                valueMobile !== "" &&
                valueMobile !== undefined)
            }
            onClick={() => {
              onChange(resetValue);
              if (isResponsive) {
                setActive("desktop");
                setValueTablet(resetValueTablet);
                setValueMobile(resetValueMobile);
              }
            }}
          />
        </div>
        <div
          className={`flex p-[2px] rounded-[6px] bg-gray-100 ${
            layout === "newline" ? "flex-wrap w-[90px] justify-around" : ""
          }`}
        >
          {options.map((e, index) => {
            return (
              <Tooltip
                key={index}
                mouseEnterDelay={0.5}
                text={e.tooltip}
                placement="top"
              >
                <div
                  className={`grigora-select-radio-input__icons relative cursor-pointer flex items-center justify-center w-6 h-6 p-1 rounded-[4px] 
                  ${
                    rotateIcon && rotateIcon > 0
                      ? `rotate-positive`
                      : rotateIcon < 0
                      ? "rotate-negative"
                      : ""
                  }`}
                  onClick={() => {
                    var currentValue =
                      active === "desktop"
                        ? value
                        : active === "tablet"
                        ? valueTablet
                        : valueMobile;

                    var newValue = e.value;

                    if (newValue === currentValue) {
                      newValue = undefined;
                    }

                    if (active === "desktop") {
                      onChange(newValue);
                    } else if (active === "tablet") {
                      setValueTablet(newValue);
                    } else {
                      setValueMobile(newValue);
                    }
                  }}
                >
                  {(
                    active === "desktop" && value === e.value
                      ? true
                      : active === "tablet" && valueTablet === e.value
                      ? true
                      : active === "mobile" && valueMobile === e.value
                      ? true
                      : false
                  ) ? (
                    <>
                      <motion.div
                        layoutId={uniqueID}
                        className="absolute top-0 bottom-0 left-0 right-0 rounded-[4px] bg-white "
                      ></motion.div>
                    </>
                  ) : (
                    <></>
                  )}
                  {e.icon}
                </div>
              </Tooltip>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default SelectRadioButtonInput;
